export default "__VITE_ASSET__9eFuhoU3__"